export default {
  namespaced: true,
  state: {
    newCompetition: {},
    competitions: {},
    searchedText: ''
  },
  mutations: {
    setNewCompetition(state, data) {
      state.newCompetition = data
    },
    setCompetitions(state, data) {
      state.competitions = data
    },
    setSearchedText(state, data) {
      state.searchedText = data
    }
  },
  actions: {
    createCompetition({ dispatch, commit }, params) {
      return dispatch(
        'app/makeCall',
        {
          route: 'competition.createCompetition',
          payload: params
        },
        { root: true }
      )
        .then((response) => {
          dispatch('app/redirectToPolling', response.data.competition._id, {
            root: true
          })
          commit('setNewCompetition', response.data)
        })
        .catch((err) => {
          throw err.response.response
        })
    },
    getCompetitions({ dispatch, commit }, { page, status, limit, search, countries = [], from = null, to = null }) {
      const searchParams = {
        page: page || null,
        status: status || null,
        limit: limit || 20,
        search: search || null,
        countries: countries.map((i) => i.name),
        from,
        to
      }
      return dispatch(
        'app/makeCall',
        {
          route: 'competition.getCompetitions',
          payload: searchParams
        },
        { root: true }
      )
        .then((response) => {
          commit('setCompetitions', response.data)
          return response.data
        })
        .catch((err) => {
          throw err.response
        })
    },
    setSearchedText({ commit }, { searchedText }) {
      commit('setSearchedText', searchedText)
    },
    getOneCompetition({ dispatch }, { id }) {
      return dispatch(
        'app/makeCall',
        {
          route: 'competition.getOneCompetition',
          payload: { id }
        },
        { root: true }
      )
        .then((response) => {
          return response.data
        })
        .catch((err) => {
          throw err
        })
    },
    updateCompetition({ dispatch }, { id, data }) {
      return dispatch(
        'app/makeCall',
        {
          route: 'competition.updateCompetition',
          payload: { id, data }
        },
        { root: true }
      )
        .then((response) => {
          dispatch('app/redirectToPolling', response.data.competition._id, {
            root: true
          })
        })
        .catch((err) => {
          throw err.response
        })
    },
    updateCompetitionStatus({ dispatch }, { id, status }) {
      return dispatch(
        'app/makeCall',
        {
          route: 'competition.updateCompetitionStatus',
          payload: { id, status }
        },
        { root: true }
      )
        .then(() => {
          dispatch('app/redirectToPolling', id, {
            root: true
          })
        })
        .catch((err) => {
          throw err.response
        })
    },
    async cloneConfiguration({ dispatch }, payload) {
      try {
        return await dispatch(
          'app/makeCall',
          {
            route: 'competition.cloneConfiguration',
            payload
          },
          { root: true }
        )
      } catch (err) {
        throw err.response
      }
    },
    async deleteCompetition({ dispatch }, payload) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'competition.deleteCompetition',
            payload
          },
          { root: true }
        )
      } catch (err) {
        throw err.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/competition.js